import React from 'react';
import {Box} from '@mui/material';
import {ReportPackFormFragment} from '../../schema-types/ReportPackFormFragment';
import {FormTypes} from '../../schema-types/globalTypes';
import {ReportPackISATransfer} from './ISATransferForm';
import {ReportPackJISATransfer} from './JISATransferForm';
import {ReportPackISAApplication} from './ISAApplicationForm';
import {ReportPackJISAApplication} from './JISAApplicationForm';
import {ReportPackNomineeTransfer} from './NomineeTransferForm';
import {ReportPackSIPPContribution} from './SIPPContributionForm';
import {ReportPackSIPPDDM} from './SIPPDDMForm';
import {ReportPackSIPPTransfer} from './SIPPTransferForm';
import {ReportPackExpressionOfWishes} from './ExpressionOfWishesForm';
import {ReportPackFurtherAction} from './FurtherActionForm';

export const ReportPackFormEditor: React.FC<{
  form: ReportPackFormFragment;
  onClose: () => void;
  disabled: boolean;
}> = ({form, disabled, onClose}) => {
  switch (form.formType) {
    case FormTypes.ISA_TRANSFER:
      return (
        <ReportPackISATransfer disabled={disabled} onClose={onClose} formData={form} />
      );
    case FormTypes.JISA_TRANSFER:
      return (
        <ReportPackJISATransfer disabled={disabled} onClose={onClose} formData={form} />
      );
    case FormTypes.ISA_APPLICATION:
      return (
        <ReportPackISAApplication disabled={disabled} onClose={onClose} formData={form} />
      );
    case FormTypes.JISA_APPLICATION:
      return (
        <ReportPackJISAApplication
          disabled={disabled}
          onClose={onClose}
          formData={form}
        />
      );
    case FormTypes.NOMINEE_TRANSFER:
      return (
        <ReportPackNomineeTransfer
          disabled={disabled}
          onClose={onClose}
          formData={form}
        />
      );
    case FormTypes.SIPP_CONTRIBUTION:
      return (
        <ReportPackSIPPContribution
          disabled={disabled}
          onClose={onClose}
          formData={form}
        />
      );
    case FormTypes.SIPP_TRANSFER:
      return (
        <ReportPackSIPPTransfer disabled={disabled} onClose={onClose} formData={form} />
      );
    case FormTypes.SIPP_DDM:
      return <ReportPackSIPPDDM disabled={disabled} onClose={onClose} formData={form} />;

    case FormTypes.EXPRESSION_OF_WISHES:
      return (
        <ReportPackExpressionOfWishes
          disabled={disabled}
          onClose={onClose}
          formData={form}
        />
      );
    case FormTypes.FURTHER_ACTION:
      return (
        <ReportPackFurtherAction disabled={disabled} onClose={onClose} formData={form} />
      );
    case FormTypes.BANK_DETAIL_COLLECTION:
      // This one doesn't need any other parameters
      // apart from the initial ones
      onClose();
      return null;
    case FormTypes.MULTREES_DDM:
      // This one doesn't need any other parameters
      // apart from the initial ones
      onClose();
      return null;
    default:
      return <Box>Nothing yet</Box>;
  }
};
